module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9860/js/img/upgrade-modal/ads_contact_list.png"